import React, { useState, useEffect, useRef } from "react";
import { ApiHitPost } from "../../../../../../Services/ApiHit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faClose } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

const Search = ({ SelectedVertical, onVerticalSelect }) => {
    const location = useLocation();
    const showVerticalDropdown = ["/", "/sample/lfkvsnl/Dashboard/vsdjnvnkdsksvdl/vfksdjnsvdk"].includes(location.pathname);

    const [InputValue, SetInputValue] = useState("");
    const [Suggestions, SetSuggestions] = useState([]);
    const [TimeoutId, SetTimeoutId] = useState(null);
    const [Verticals, SetVerticals] = useState([]);
    const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false);
    const inputRef = useRef(null);
    const suggestionsRef = useRef(null);
    const SearchTextRef = useRef(null);

    const FetchSuggestions = async (SearchTerm) => {
        try {
            const response = await ApiHitPost("/Dashboard/get_search_tags", {
                tag_initials: SearchTerm,
            });
            let suggestions = response.data.matching_tags_list.filter((tag) => tag);
            if (suggestions.length <= 0) {
                suggestions = ["No Result Found"];
            }
            SetSuggestions(suggestions);
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };

    useEffect(() => {
        if (TimeoutId) {
            clearTimeout(TimeoutId);
        }

        if (InputValue.trim().length >= 3) {
            const newTimeoutId = setTimeout(() => {
                if (InputValue.length >= 3) {
                    FetchSuggestions(InputValue);
                }
            }, 500);

            SetTimeoutId(newTimeoutId);
        } else {
            SetSuggestions([]);
        }

        return () => {
            if (TimeoutId) {
                clearTimeout(TimeoutId);
            }
        };
    }, [TimeoutId, InputValue]);

    useEffect(() => {
        const handleScroll = () => {
            SetSuggestions([]);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const FetchVeticals = async () => {
        try {
            const response = await ApiHitPost("/hierarchy/get_vertical_list");
            const AllVerticals = response.data.data;
            SetVerticals(AllVerticals);
        } catch (error) {
            console.error("Error fetching verticals:", error);
        }
    };

    useEffect(() => {
        FetchVeticals();
    }, []);

    const HandleChange = (e) => {
        SetInputValue(e.target.value);
    };

    const HandleMobileSearchToggle = () => {
        setIsMobileSearchVisible(!isMobileSearchVisible);
        if (!isMobileSearchVisible && SearchTextRef.current) {
            SearchTextRef.current.focus();
        }
    };

    const handleSearchSuggesstionClick = (searchTag) => {
        localStorage.setItem("dla_web_student_search_tag", searchTag);
        localStorage.setItem("dla_web_student_search_tag_text", searchTag);
        window.location.href = "/search";
    };

    return (
        <div className="relative w-full md:w-[400px] lg:w-[450px]">
            {/* Web View: Always show input */}
            <div className="hidden md:flex relative items-center" ref={inputRef}>
                <div className="absolute left-3 text-gray-400">
                    <FontAwesomeIcon icon={faSearch} className="w-4 h-4" />
                </div>
                <input
                    type="text"
                    ref={SearchTextRef}
                    className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 placeholder-gray-400 placeholder-opacity-40"
                    placeholder="What do you want to learn..."
                    value={InputValue}
                    onChange={HandleChange}
                />
                {Suggestions.length > 0 && (
                    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg top-full" style={{ maxHeight: "300px", overflowY: "auto" }} ref={suggestionsRef}>
                        {Suggestions.map((suggestion, index) => (
                            <a onClick={() => handleSearchSuggesstionClick(suggestion)} key={index} className="block px-4 py-2 hover:bg-gray-50 cursor-pointer">
                                {suggestion}
                            </a>
                        ))}
                    </div>
                )}
            </div>

            {/* Mobile View: Toggle input visibility */}
            <div className="md:hidden">
                {!isMobileSearchVisible && (
                    <button onClick={HandleMobileSearchToggle} className="text-gray-400">
                        <FontAwesomeIcon icon={faSearch} className="w-6 h-6" />
                    </button>
                )}
                {isMobileSearchVisible && (
                    <div className="fixed inset-0 bg-white z-50 flex flex-col p-4">
                        <div className="flex items-center">
                            <input
                                type="text"
                                ref={SearchTextRef}
                                className="flex-1 pl-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 placeholder-gray-400"
                                placeholder="Search..."
                                value={InputValue}
                                onChange={HandleChange}
                            />
                            <button onClick={HandleMobileSearchToggle} className="text-gray-400 ml-2">
                                <FontAwesomeIcon icon={faClose} className="w-6 h-6" />
                            </button>
                        </div>
                        {Suggestions.length > 0 && (
                            <div className="mt-2 bg-white border rounded-md shadow-lg" style={{ maxHeight: "400px", overflowY: "auto" }} ref={suggestionsRef}>
                                {Suggestions.map((suggestion, index) => (
                                    <a onClick={() => handleSearchSuggesstionClick(suggestion)} key={index} className="block px-4 py-2 hover:bg-gray-50 cursor-pointer">
                                        {suggestion}
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Search;
